import { render, staticRenderFns } from "./configAdminDialog.vue?vue&type=template&id=1092209c&"
import script from "./configAdminDialog.vue?vue&type=script&lang=js&"
export * from "./configAdminDialog.vue?vue&type=script&lang=js&"
import style0 from "./configAdminDialog.vue?vue&type=style&index=0&id=1092209c&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports